import SHAREBOX_I32_BREAKDOWN_STEPS from './i32';

const SHAREBOX_W64_BREAKDOWN_STEPS = SHAREBOX_I32_BREAKDOWN_STEPS;

export default SHAREBOX_W64_BREAKDOWN_STEPS;
